export default require("./node_modules/@inertiajs/progress/dist/index.js");